import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initGoogleTag } from './utils/gtag';
import { initGTM } from './utils/gtm';
type PaletteMode = 'light' | 'dark';
export function App() {
  const [mode, setMode] = useState<PaletteMode>('light');
  const toggleMode = () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    document.documentElement.setAttribute('data-mode', newMode);
  };
  useEffect(() => {
    // Set initial mode on mount
    document.documentElement.setAttribute('data-mode', mode);
    // Initialize Google Analytics
    initGoogleTag();
    // Initialize Google Tag Manager
    initGTM();
  }, []);
  return <LandingPage mode={mode} toggleMode={toggleMode} data-id="element-0" />;
}